
export const OPTIONS = {
    TRAVAIL_A_FAIRE_DE: 'Travail à faire de',
    TRAVAIL_FAIT_PAR: 'Travail fait par',
    LISTE_DES_COMPETENCES: 'Liste des compétences',
    SERIE_EN_COURS: 'Série en cours',
    CHAPTERS_STUDENT_GROUP: 'Chapitres de ',
    PARCOURS: 'Parcours de'
};
